export default "__VITE_ASSET__H0491tI6__"